<template>
  <div class="bg-white rounded-10 p-10 text-left flex">
    <div class="w-1/2 pr-10 mr-10">
      <div class="mt-10">
        <div class="">
          <div class="text-c16 text-90">
            Montant disponible: <span class="text-black">{{ totalStat.toLocaleString() }} F</span>
          </div>
        </div>

        <div class="mt-6">
          <div class="text-c16 text-90">
            Montant déposé: <span class="text-black"> {{ total.toLocaleString() }} F </span>
          </div>
        </div>

        <div class="mt-6">
          <div class="text-c16 text-90">
            Montant restant:
            <span class="text-black" v-if="!specialStat"> {{ (totalStat + total).toLocaleString() }} F </span>
            <span class="text-black" v-if="specialStat"> {{ (totalStat - total).toLocaleString() }} F </span>
          </div>
        </div>

        <div class="mt-6">
          <div class="text-c16 text-90">
            Type de remise: <span class="text-black"> {{ type }} </span>
          </div>
        </div>
      </div>
    </div>

    <div class="w-1/2 pl-20">
      <div class="mt-14">
       <upload value="Pièce justificative" @info="retourUpload"/>

        <textare radius="5px" height="150px" class="mt-6"  @info="retourNote"/>
      </div>
    </div>
  </div>
</template>

<script>
import upload from '../../helper/form/uploadPreuve'
import textare from '../../helper/form/textarea'

export default {
  name: "Index",
  components: {
    upload,
    textare
  },
  props: {
    total: {
      type: Number,
      default: 0
    },

    type: {
      type: String,
      default: null
    },

    specialStat: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      allBillet: [],
      forget: false,
      banque: null,
      response: {},
      totalStat: 0
    }
  },

  created () {
    this.banque = this.$store.getters.trackTemporal
    if (!this.specialStat) {
      this.totalStat = this.banque.amount
    } else {
      if (this.type === 'Espèce') {
        this.totalStat = this.specialStat.cashAmount
      } else {
        this.totalStat = this.specialStat.checkAmount
      }

    }

  },

  methods: {
    sender () {
      this.$emit('info', this.response)
    },

    retourUpload (answer) {
      this.response.file = answer
      this.sender()
    },

    retourNote (answer) {
      this.response.note = answer
      this.sender()
    }
  },
}
</script>

<style lang="scss" scoped>
.svg-icon{
  fill: transparent;
}
.bloc2 {
  border-left: 0.352891px solid #DDDDDD;
}
</style>
